<template>
  <div class="greatField">
    <div class="greatField-title">擅长领域</div>
    <div class="greatField-con">
      <div class="greatField-con-search">
        <el-input
          placeholder="按姓名搜索"
          v-model="name"
          @keyup.native.enter="getExpertByName"
          ref="search"
        >
          <template slot="append">
            <div class="greatField-con-search-icon" @click="getExpertByName"></div>
          </template>
        </el-input>
      </div>
      <div class="greatField-con-left">
        <div
          class="leftItem"
          v-for="(item, index) in fieldList"
          :key="index"
          @click="fieldIndex = index"
          :class="fieldIndex == index ? 'cur' : ''"
        >
          <!-- <div class="listIcon"></div> -->
          <div class="leftItem-title" @click="getExpertList(item.uuid)">{{ item.title }}</div>
        </div>
      </div>
      <div class="greatField-con-right">
        <div
          class="rightItem"
          v-for="(item, index) in expertList"
          :key="index"
          @click="goExpertDetail(item)"
        >
          <div class="rightItem-head" :style="{ backgroundImage: `url(${item.avatar})` }"></div>
          <div class="rightItem-name">{{ item.name }}</div>
          <div class="rightItem-job">{{ item.job }}</div>
          <!-- <div class="rightItem-field over-num-lines"> -->
          <!-- <span v-for="(subject, i) in item.expertSubjectList" :key="i">
                            <span>{{ subject.title + ' '}}</span>
          </span>-->
          <!-- {{ item.summary }}
          </div>-->
        </div>
        <div v-if="expertList.length == 0" class="empty">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getFieldList,
  getExpertList,
  getExpertByName
} from "../../utils/interface";
export default {
  name: "greatField",
  components: {},
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      fieldList: [
        { title: "咨询规划" },
        { title: "制造领域" },
        { title: "咨询规划咨询规划" }
      ],
      fieldIndex: 0,
      expertList: [
        // {
        //     avatar: require('../../assets/publicService/resourcePool/avater.png'),
        //     name: '田志刚',
        //     expertJobList: [
        //         { title: '教授' },
        //         { title: '博士生导师' }
        //     ], // 职位
        //     expertSubjectList: [
        //         { title: '制造领域' },
        //         { title: '大数据领域' }
        //     ], // 擅长领域
        // }
      ],
      name: ""
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.getFieldList();
    if (this.$route.query.title) {
      let timer = setInterval(() => {
        if (this.title) {
          clearInterval(timer);
          this.name = this.title;
          this.$refs.search.focus();
          this.getExpertByName();
        }
      });
    } else {
      this.getExpertByName();
    }
  },
  methods: {
    // 获取专家领域分类列表
    getFieldList() {
      getFieldList().then(res => {
        if (res && res.length > 0) {
          this.fieldList = res;
          this.expertList = [];
          // this.getExpertList(res[0].uuid)
        } else {
          this.fieldList = [];
        }
      });
    },
    // 根据专家领域id查询专家列表
    getExpertList(uuid) {
      this.expertList = [];
      getExpertList(uuid).then(res => {
        if (res.success) {
          this.expertList = res.data.expertList;
        } else {
          this.expertList = [];
        }
      });
    },
    // 根据姓名查询专家列表，左侧分类选中状态取消
    getExpertByName() {
      getExpertByName({
        status: "1",
        // rec: '1',
        name: this.name
      }).then(res => {
        this.fieldIndex = null;
        if (res && res.length > 0) {
          this.expertList = res;
        } else {
          this.expertList = [];
        }
      });
    },
    // 进入专家详情页面
    goExpertDetail(item) {
      let router = this.$router.resolve({
        path: "/expertDetail",
        query: {
          uuid: item.uuid,
          name: item.name
        }
      });
      window.open(router.href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
.greatField {
  width: 100%;
  height: 650px;
  background: url("../../assets/publicService/resourcePool/8.png") no-repeat
    center center/100% 100%;
  overflow: hidden;

  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .empty {
    font-size: 24px;
    font-weight: 500;
    color: #5566779e;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .greatField-title {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    margin: 20px 0;
  }

  .greatField-con {
    width: 1300px;
    height: 500px;
    margin: 0 auto;
    // background-color: transparent;
    background-color: #ffffff85;
    display: flex;
    flex-flow: row nowrap;
    justify-content: start;
    position: relative;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;

    .greatField-con-search {
      position: absolute;
      top: -38px;
      right: 0px;

      .greatField-con-search-icon {
        width: 26px;
        height: 27px;
        background: url("../../assets/publicService/search.png") no-repeat
          center center/18px 18px;
      }
    }

    .greatField-con-left {
      width: 160px;
      height: 100%;
      background: url("../../assets//publicService/resourcePool/13.png")
        no-repeat center center/96% 100%;
      background-origin: border-box;
      display: flex;
      flex-flow: column nowrap;
      justify-content: start;
      overflow-y: scroll;

      .cur {
        background-color: rgb(255 255 255/0.2);
      }

      .leftItem {
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        cursor: pointer;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        font-size: 14px;

        .listIcon {
          width: 13px;
          height: 13px;
          background: url("../../assets/publicService/resourcePool/listIcon.png");
          margin-left: 15px;
        }

        .leftItem-title {
          flex: 1;
          text-align: left;
          padding-left: 25px;
          font-size: 16px;
          font-weight: 600;
        }
      }

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #fff;
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }

    .greatField-con-right {
      display: flex;
      flex: 1;
      flex-flow: row wrap;
      justify-content: start;
      align-items: start;
      overflow-y: scroll;
      // box-shadow: 0 0 10px #44556638;
      position: relative;
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;

      .rightItem {
        width: 188px;
        height: 250px;
        display: flex;
        flex-flow: column nowrap;
        justify-content: start;
        align-items: center;
        padding: 4px 0;
        box-sizing: border-box;
        border-right: 1px solid #fff;
        border-bottom: 1px solid #fff;
        cursor: pointer;
        padding: 5px;

        &:nth-of-type(6n) {
          border-right: none;
        }

        .rightItem-head {
          width: 120px;
          height: 170px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .rightItem-name {
          color: #2d50a1;
          margin-top: 10px;
        }

        .rightItem-job,
        .rightItem-field {
          color: #666a73;
          font-size: 14px;
          margin-top: 5px;
        }
      }

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #fff;
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }
  }
}

/* 搜索框样式 */
/deep/ .el-input-group--append .el-input__inner {
  height: 32px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  border: none;
}

/* 搜索图标样式 */
/deep/ .el-input-group__append {
  padding: 0 12px;
  background-color: #fff;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  border: none;

  &:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcePool/greatField.vue